export const GET_PROJECT_ACCEPTANCE_REQUEST = 'GET_PROJECT_ACCEPTANCE_REQUEST';
export const GET_PROJECT_ACCEPTANCE_SUCCESS = 'GET_PROJECT_ACCEPTANCE_SUCCESS';
export const GET_PROJECT_ACCEPTANCE_FAILURE = 'GET_PROJECT_ACCEPTANCE_FAILURE';
